import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Grid } from "@material-ui/core";

import LoadingComponent from "../CommonComponents/loadinComponent";
import TopView from "../CommonComponents/topView";
import CommonTable from "../CommonComponents/CommanTable";
import EnhancedTableToolbar from "../CommonComponents/EnhancedTableToolbar";
import CommanExcelExport from "../CommonComponents/CommanExcelExport";
import ExportPdf from "../CommonComponents/exportPdf";
import CustomHeaderModal from "../CommonComponents/CustomHeaderModal";

import { isArray } from "lodash";
import moment from "moment";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";
import useApiFetch from "../CommonComponents/CommonFetchApi/fetchAllDropdownListApi";
import { TripPerformanceAction } from "../../actions/TripPerformance";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "7rem",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function TripPerformance() {
  const { showSnackbar } = useSnackbar();
  const classes = useStyles();

  const [tripData, setTripData] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [selectedMine, setSelectedMine] = useState({});
  const [selectedArea, setSelectedArea] = useState({});
  const [categoryWiseList, setCategoryWiseList] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [openToolBar, setOpenToolBar] = useState(false);
  const [customModalOpen, setCustomModalOpen] = useState(false);
  const [customHeaders, setCustomHeaders] = useState([]);
  const [headerConfig, setHeaderConfig] = useState([]);
  const [isCustomHeaderApplied, setIsCustomHeaderApplied] = useState(false);
  const [activeFilterCount, setActiveFilterCount] = useState(0);
  const [filteredMineList, setFilteredMineList] = useState([]);
  const [permissionAccess] = React.useState(
    JSON.parse(sessionStorage.getItem("data")),
  );

  const tripPerformancePer = permissionAccess.menuVisiblity.find(
    (menu) => menu.name === "TRIP_PERFORMANCE",
  );
  const labelHeader = [
    {
      name: "S. No",
      keyName: "sNo",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "Mine Name",
      keyName: "mineName",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "Area Name",
      keyName: "areaName",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "Date",
      keyName: "date",
      isShow: true,
      isExportShow: true,
      isDate: true,
      isNoTime: true,
    },
    {
      name: "Morning Shift Trip (Actual Count / Avg Count)",
      keyName: "morningExpectedAvgTrips",
      keyName2: "morningTripCount",
      isShow: true,
      isExportShow: true,
      isratio: true,
    },
    {
      name: "Evening Shift Trip(Actual Count / Avg Count)",
      keyName: "eveningExpectedAvgTrips",
      keyName2: "eveningTripCount",
      isShow: true,
      isExportShow: true,
      isratio: true,
    },
    {
      name: "Night Shift Trip(Actual Count / Avg Count)",
      keyName: "nightExpectedAvgTrips",
      keyName2: "nightTripCount",
      isShow: true,
      isExportShow: true,
      isratio: true,
    },
  ];

  const { fetchSiteList } = useApiFetch();

  useEffect(() => {
    if (categoryWiseList?.mineList) {
      setFilteredMineList(categoryWiseList.mineList);
    }
  }, [categoryWiseList]);

  useEffect(() => {
    let count = 0;
    if (selectedDate) count++;
    if (selectedMine && Object.keys(selectedMine).length > 0) count++;
    setActiveFilterCount(count);
  }, [selectedDate, selectedMine]);

  useEffect(() => {
    const savedConfig = sessionStorage.getItem("tripPerformanceTableHeaders");
    if (savedConfig) {
      try {
        const parsedConfig = JSON.parse(savedConfig);
        const visibleHeaders = parsedConfig.filter(
          (header) => header.isVisible,
        );
        const defaultVisibleCount = labelHeader.filter((h) => h.isShow).length;

        setIsCustomHeaderApplied(
          visibleHeaders.length > 0 &&
            visibleHeaders.length !== defaultVisibleCount,
        );
        setCustomHeaders(visibleHeaders);
        setHeaderConfig(parsedConfig);
      } catch (error) {
        console.error("Error loading header configuration:", error);
        setIsCustomHeaderApplied(false);
      }
    } else {
      const defaultConfig = labelHeader.map((header, index) => ({
        ...header,
        order: index,
        isVisible: header.isShow !== false,
      }));
      const defaultVisible = labelHeader.filter((header) => header.isShow);
      setCustomHeaders(defaultVisible);
      setHeaderConfig(defaultConfig);
    }
  }, []);

  const handleSaveHeaderConfig = (newConfig) => {
    try {
      const cleanConfig = JSON.parse(
        JSON.stringify(newConfig, (key, value) => {
          if (
            key.startsWith("_") ||
            typeof value === "function" ||
            key === "icon" ||
            key === "isIcon"
          ) {
            return undefined;
          }
          return value;
        }),
      );

      const visibleHeaders = cleanConfig.filter((header) => header.isVisible);
      setCustomHeaders(visibleHeaders);
      setHeaderConfig(cleanConfig);

      setIsCustomHeaderApplied(
        visibleHeaders.length > 0 &&
          visibleHeaders.length !== labelHeader.filter((h) => h.isShow).length,
      );

      sessionStorage.setItem(
        "tripPerformanceTableHeaders",
        JSON.stringify(cleanConfig),
      );
    } catch (error) {
      console.error("Error saving header configuration:", error);
    }
  };

  const fetchTripPerformance = useCallback(
    async (type, exportType) => {
      try {
        setLoading(true);

        const payload = {
          pageNo: type ? pageNo : 0,
          pageSize: type ? pageSize : 0,
          mineId: selectedMine?.id || "",
          areaId: selectedArea?.id || "",
          dateinMillis: selectedDate ? moment(selectedDate).valueOf() : "",
        };

        const response = await TripPerformanceAction.fetchTripPerformanceList(
          payload,
          showSnackbar,
        );

        if (!response || !response.data) {
          setTripData([]);
          setTotalElements(0);
          setLoading(false);
          return;
        }

        if (type) {
          const mappedData = extractTripData(
            response.data.data || [],
            pageNo,
            pageSize,
          );
          setTripData(mappedData);
          setTotalElements(response.data.totalElements || 0);
        } else {
          const allData = extractTripData(response.data.data || [], 0, 0);
          setExportData(allData);

          setTimeout(() => {
            const triggerExport = (elementId) => {
              const el = document.getElementById(elementId);
              if (el) el.click();
            };

            if (exportType === "excel") {
              triggerExport("styleExportExcel");
            } else if (exportType === "pdf") {
              triggerExport("exportPdfButton");
            }
          }, 500);
        }
      } catch (error) {
        console.error("Error fetching trip performance data:", error);
        showSnackbar("Failed to fetch trip performance data", "error");
        setTripData([]);
        setTotalElements(0);
      } finally {
        setLoading(false);
      }
    },
    [pageNo, pageSize, selectedDate, selectedMine, selectedArea],
  );

  const extractTripData = (data, currentPage, pageSize) => {
    if (!Array.isArray(data)) return [];

    return data.map((item, index) => {
      const serialNo =
        pageSize > 0 ? currentPage * pageSize + index + 1 : index + 1;

      return {
        sNo: serialNo,
        mineId: item.mineId,
        areaId: item.areaId,
        mineName: item.mineName || "N/A",
        areaName: item.areaName || "N/A",
        date: item.date || selectedDate,
        morningExpectedAvgTrips: item.morningExpectedAvgTrips || 0,
        morningTripCount: item.morningTripCount || 0,
        eveningExpectedAvgTrips: item.eveningExpectedAvgTrips || 0,
        eveningTripCount: item.eveningTripCount || 0,
        nightExpectedAvgTrips: item.nightExpectedAvgTrips || 0,
        nightTripCount: item.nightTripCount || 0,
      };
    });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    // setFilterApplied(true);
    // setPageNo(0);
  };

  const handleMineChange = (mine) => {
    setSelectedMine(mine || {});
    // setFilterApplied(true);
    // setPageNo(0);
  };
  const handleAreaChange = (area) => {
    setSelectedArea(area || {});
    setSelectedMine({});
    // setPageNo(0);
    // setFilterApplied(true);

    if (area && area.id) {
      const minesByArea = categoryWiseList?.mineList?.filter(
        (mine) => mine.parentSiteId === area.id,
      );
      setFilteredMineList(minesByArea || []);
    } else {
      setFilteredMineList(categoryWiseList?.mineList || []);
    }
  };

  const getExportData = (type) => {
    fetchTripPerformance(false, type);
  };

  const toggleOpenToolBar = () => {
    setOpenToolBar(!openToolBar);
  };

  useEffect(() => {
    fetchSiteList(undefined, setCategoryWiseList);
    setFilterApplied(true);
  }, []);

  useEffect(() => {
    if (filterApplied) {
      fetchTripPerformance(true);
      setFilterApplied(false);
    }
  }, [filterApplied, pageNo, pageSize]);

  const submitHandler = () => {
    setPageNo(0);
    setFilterApplied(true);
  };

  const dropdowns = [
    {
      label: "Select Date",
      type: "date",
      valueKey: "selectedDate",
      value: selectedDate,
      placeholder: "Select Date",
      onChangeHandler: handleDateChange,
    },
    {
      label: "Select Area",
      options: categoryWiseList?.areaList || [],
      valueKey: "name",
      value: selectedArea,
      placeholder: "Select Area",
      optionKey: "name",
      type: "autocomplete",
      onChangeHandler: handleAreaChange,
    },
    {
      label: "Select Mine",
      options: filteredMineList,
      valueKey: "name",
      value: selectedMine,
      placeholder: "Select Mine",
      optionKey: "name",
      type: "autocomplete",
      onChangeHandler: handleMineChange,
    },
    {
      label: "",
      type: "button",
      buttonText: "Submit",
      buttonVariant: "contained",
      buttonClass: "ml-1",
      onClickHandler: submitHandler,
    },
  ];

  const topViewData = {
    title: "Trip Performance",
    subTitleFirst: "Dashboard >",
    subTitleThird: "Trip Performance",
    buttonIcon: false,
    backPath: "/dashboard",
    backPathSecond: "/dashboard",
    export: true,
    showPdfButton: tripPerformancePer?.exportPermission,
    showExcelButton: tripPerformancePer?.exportPermission,
    getExportData: getExportData,
    openToolBar,
    toggleOpenToolBar,
    customheader: true,
    setCustomModalOpen,
    isCustomHeaderApplied: isCustomHeaderApplied,
    hasActiveFilters: activeFilterCount > 0,
    activeFilterCount: activeFilterCount,
  };

  return (
    <div>
      <LoadingComponent isLoading={isLoading} />
      <Container>
        <TopView data={topViewData} />

        <div style={{ display: "none" }}>
          <CommanExcelExport
            headers={
              customHeaders.length > 0
                ? customHeaders
                : labelHeader.filter((h) => h.isShow)
            }
            rows={isArray(exportData) ? exportData : [exportData]}
            exportHeading={["Trip Performance Report"]}
            reportType={"Trip Performance"}
          />
          <ExportPdf
            headers={
              customHeaders.length > 0
                ? customHeaders
                : labelHeader.filter((h) => h.isShow)
            }
            rows={exportData || []}
            title="Trip Performance Report"
            reportName="tripPerformanceReport"
          />
        </div>

        <EnhancedTableToolbar
          dropdowns={dropdowns}
          drawerOpen={openToolBar}
          setDrawerOpen={setOpenToolBar}
        />

        <Grid className="tableSection">
          <CommonTable
            headers={
              customHeaders.length > 0
                ? customHeaders
                : labelHeader.filter((h) => h.isShow)
            }
            rows={tripData || []}
            pageNo={pageNo}
            setPageNo={setPageNo}
            totalPages={totalElements}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setBool={setFilterApplied}
          />
        </Grid>
      </Container>

      <CustomHeaderModal
        open={customModalOpen}
        onClose={() => setCustomModalOpen(false)}
        headers={labelHeader}
        onSave={handleSaveHeaderConfig}
        currentConfig={headerConfig}
      />
    </div>
  );
}

export default TripPerformance;
